<template>
  <div id="engine-details" class="flex flex-column form-group" :class="productType">
    <div class="flex flex-vcenter title">
      <label v-if="productType != 'airframe'" class="control-label required"
        >Engine Models
        <tooltip
          content="Please only select engine models for which you are requesting support."
          effect="scale"
          placement="right"
          ><i class="fa fa-question-circle"></i></tooltip
      ></label>
      <label :class="['control-label', {required: productType != 'commercial'}]"
        >Aircraft Type
        <tooltip
          content="Please only select aircraft models for which you are requesting support."
          effect="scale"
          placement="right"
          ><i class="fa fa-question-circle"></i></tooltip
      ></label>
      <label v-if="productType === 'bga'" class="control-label required">Aircraft Serial Number</label>
      <label v-if="productType === 'commercial'" class="control-label">Quantity of Engines</label>
      <label v-else-if="showEngineQuantity" class="control-label required">Quantity of Aircraft</label>
    </div>
    <div v-for="(engine, index) in engineDetails" :key="index" class="flex flex-row engine-list">
      <div v-if="productType != 'airframe'" class="engine-model">
        <select id="engineModel" v-model="engine.engineModel" class="form-control" name="engineModel">
          <option value="" selected>Select Engine models</option>
          <option v-for="(modelName, k) in engineModelList" :key="k" :value="modelName"> {{ modelName }} </option>
        </select>
        <div v-if="engine.engineModel === 'Other'">
          <input
            v-model.trim="engine.otherEngineModel"
            type="text"
            placeholder="Enter engine model"
            class="form-control"
          />
        </div>
      </div>
      <div class="engine-aircraft">
        <select id="engineModel" v-model="engine.aircraftType" class="form-control" name="engineModel">
          <option value="" selected>Select Aircraft Type</option>
          <option v-for="(type, k) in aircraftTypeList" :key="k" :value="type"> {{ type }} </option>
        </select>
        <div v-if="engine.aircraftType === 'Other'">
          <input
            v-model.trim="engine.otherAircraftType"
            type="text"
            placeholder="Enter aircraft type"
            class="form-control"
          />
        </div>
      </div>
      <div v-if="productType === 'bga'" class="engine-quantity">
        <input v-model.trim="engine.aircraftSrlNum" class="form-control" type="text" />
      </div>
      <div v-if="showEngineQuantity" class="engine-quantity">
        <input
          v-model="engine.aircraftNumber"
          class="form-control"
          type="number"
          min="0"
          oninput="this.value = Math.abs(this.value)"
        />
      </div>
      <!-- dont show delete icon when length is 1 -->
      <span
        v-show="engineDetails.length > 1"
        class="fa fa-trash fa-lg text-danger pointer"
        @click="removeEngine(index)"
      ></span>
    </div>
    <div v-if="error" class="text-danger">Please fill all the valid details</div>
    <div>
      <a id="add-new-row" class="add-row" @click="addNewRow"> <i class="fa fa-plus-circle"></i> Add Row </a>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import tooltip from "build-ui-x/src/Tooltip";

export default {
  components: {
    tooltip
  },
  props: {
    productType: {
      type: String,
      default: ""
    },
    v: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapState("product", ["productTypes"]),
    engineDetails() {
      return this.$store.state.product.productTypes[this.productType].productInfo.engineDetails;
    },
    aircraftTypeList() {
      return this.$store.state.productInfo[this.productType].aircraftType;
    },
    engineModelList() {
      return this.$store.state.productInfo[this.productType].engineModel;
    },
    error() {
      return this.v.productTypes[this.productType].productInfo.engineDetails.$error;
    },
    showEngineQuantity() {
      return (
        this.productType !== "bga" &&
        this.$store.state.product.productTypes[this.productType].companyDetails.companyTypeId != "6"
      );
    }
  },
  methods: {
    addNewRow: function() {
      this.v.productTypes[this.productType].productInfo.engineDetails.$touch();
      if (this.v.productTypes[this.productType].productInfo.engineDetails.$invalid) {
        return;
      } else {
        this.v.productTypes[this.productType].productInfo.engineDetails.$reset();
        this.$store.dispatch("product/addNewEngine", this.productType);
      }
    },
    removeEngine(index) {
      this.$store.dispatch("product/removeEngine", {
        productType: this.productType,
        index
      });
    }
  }
};
</script>
<style lang="less" scoped>
#engine-details {
  max-width: 600px;
  min-width: 400px;

  &.airframe {
    min-width: 300px;
    max-width: 400px;
  }

  .engine-list {
    margin-bottom: 8px;
    align-items: baseline;
  }

  #add-new-row {
    margin-top: 5px;
  }

  .title label,
  .engine-model,
  .engine-aircraft,
  .engine-quantity {
    width: 100%;
    margin-right: 10px;

    input {
      margin: 5px 0 0 0;
    }
  }

  .fa-trash {
    margin-top: 8px;
  }

  .add-row {
    cursor: pointer;
    color: #3b73b9;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 14px;
    line-height: 20px;
  }
}
</style>
